import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary } from '@softline/core';
import { SOFTLINE_API_MDC_INVENTORY_PRODUCT_DETAIL } from '../mde-inventory.api';
import { MdcInventoryDetail } from '../types/inventory-detail';
import { MdcInventoryItem } from '../types/inventory-item';

@Injectable({ providedIn: 'root' })
export class MdcInventoryItemRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  items(id: number, productId: number): Promise<(MdcInventoryItem & {})[]> {
    return this.dataAccess.get({
      path: SOFTLINE_API_MDC_INVENTORY_PRODUCT_DETAIL,
      pathParams: {
        id,
        productId,
      },
    });
  }
}
